import { vodAutoRefreshMinutes } from '@/shared/constants'
import { useVODStore } from '@/shared/store'
import { useEffect } from 'react'

const useAutoRefresh = () => {
    const { resetVODCache } = useVODStore()
    useEffect(() => {
        resetVODCache()

        const id = setInterval(() => {
            resetVODCache()
        }, vodAutoRefreshMinutes)

        return () => clearInterval(id)
    }, [resetVODCache, vodAutoRefreshMinutes])
}

export default useAutoRefresh
